import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MeetingInfo } from 'src/app/models/meetings/meeting.model';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { MeetingService } from 'src/app/services/meetings/meeting.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss'],
})
export class AddEventComponent implements OnInit {
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  quillTxt: any;
  schId: any;
  mailBody: any;
  mailSubject: string;
  modules: any;
  venue: string;
  inviteEndDate: Date;
  inviteStartDate: Date;
  moduleid = 0;
  selectedCode: any;
  name: string;
  isreadonly = false;
  disableButtons = true;
  moduleBatches: SchoolModuleBatch[] = [];
  lessons:any;
  lessonId=0;
  selectedBatchId: number = 0;
  defaultBatch: SchoolModuleBatch  = {
    id: 0,
    name: 'All Batches',
    startDate: undefined,
    endDate: undefined,
    moduleID: 0,
    meetingID: ''
  };
  allowBatch: false;
  disableLinkBtn=false;
  meetingID :string;
  constructor(
    public headerinfo: ComponentheaderService,
    public schoolservice: SchoolmanagementService,
    public toastr: ToastrService,
    public moduleservice: ModulemanagementService,
    public classservice: ClassmanagementService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private meetingService:MeetingService
  ) {}

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);

    this.moduleid = this.activatedroute.snapshot.queryParams.moduleID;
      this.headerinfo.setHeaderDisplay(
      'Add New Event',
      [
        { displaytext: 'School', route: `/user/schoolhome` },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        { displaytext: 'Course Events', route: '/events/view', params: {moduleID: this.moduleid} },
        { displaytext: 'Create Event', route: '/events/add' },
      ],
      []
    );

    const school: any = await this.schoolservice
      .getSchoolFromSubdomain();

    let moduleDetails : any = await this.moduleservice.getModuleDetails(this.moduleid).toPromise();
    this.allowBatch = moduleDetails.allowBatches;
    if(this.allowBatch){
      this.moduleBatches = await this.moduleservice.getModuleBatches(this.moduleid).toPromise();
      if(this.moduleBatches.length === 1)
        this.selectedBatchId = this.moduleBatches[0].id;
    }
    this.lessons = await this.classservice.getModuleLessons(this.moduleid).toPromise();
    this.lessonId = Number(this.activatedroute.snapshot.queryParams.classid);
    this.schId = school.id;
    this.disableButtons = false;
    this.headerinfo.pageLoadingDone(this);
  }

  async testInviteMail() {
    this.headerinfo.pageLoadingStarted(this);
    this.disableButtons = true;
    if (!this.checkModelValid()) {
      this.headerinfo.pageLoadingDone(this);
      return;
    }
    let data = {
      body: this.mailBody,
      subject: this.mailSubject,
      moduleId: this.moduleid,
      schoolId: this.schId,
      venue: this.venue,
      inviteEndDate: this.inviteEndDate,
      inviteStartDate: this.inviteStartDate,
    };

    if (this.moduleid) {
      data.moduleId = this.moduleid;
    }
    await this.moduleservice
      .testModuleInviteMail(data)
      .toPromise()
      .then((res: any) => {
        this.toastr.success('An email has been sent to ' + res.res);
      })
      .catch((err) => {
        this.toastr.error(err);
        this.disableButtons = false;
        return;
      });

    this.disableButtons = false;
    this.headerinfo.pageLoadingDone(this);
  }

  async sendInviteMail() {
    this.headerinfo.pageLoadingStarted(this);

    this.disableButtons = true;
    if (!this.checkModelValid()) {
      this.headerinfo.pageLoadingDone(this);
      return;
    }
    let data = {
      body: this.mailBody,
      subject: this.mailSubject,
      moduleId: this.moduleid,
      schoolId: this.schId,
      venue: this.venue,
      inviteEndDate: this.inviteEndDate,
      inviteStartDate: this.inviteStartDate,
      batchId: this.selectedBatchId,
      classId:this.lessonId,
      meetingID: this.meetingID
    };

    if (this.moduleid) {
      data.moduleId = this.moduleid;
    }
    await this.moduleservice
      .createModuleInviteMail(data)
      .toPromise()
      .then(() => {
        this.toastr.success('Email Invite Sent.');
      })
      .catch((err) => {
        this.disableButtons = false;
        this.toastr.error(err);
        return;
      });
    this.disableButtons = false;
    this.headerinfo.pageLoadingDone(this);

    if(this.moduleid){//i don't know whey the moduleid wouldn't be set, and it looks like the page won't work without moduleid being set anyway
      this.router.navigate(['/events/view'], { queryParams: { moduleID: this.moduleid } });
    }
  }

  checkModelValid() {
    if (
      this.mailSubject == '' ||
      this.mailSubject == undefined ||
      this.mailSubject == null
    ) {
      this.toastr.warning('Event Subject is required');
      this.disableButtons = false;
      return false;
    }

    if(this.selectedBatchId == undefined){
      this.toastr.warning('Batch is required');
      this.disableButtons = false;
      return false;
    }

    if (
      this.inviteEndDate == null ||
      this.inviteEndDate == undefined ||
      this.inviteEndDate == null
    ) {
      this.toastr.warning('Event End Date is required');
      this.disableButtons = false;
      return false;
    }

    if (
      this.inviteStartDate == null ||
      this.inviteStartDate == undefined ||
      this.inviteStartDate == null
    ) {
      this.toastr.warning('Event Start Date is required');
      this.disableButtons = false;
      return false;
    }
    if (this.inviteEndDate < this.inviteStartDate) {
      this.toastr.warning(
        'Event End Date should be greater than Event Start Date'
      );
      this.disableButtons = false;
      return false;
    }
    if (this.venue == '' || this.venue == undefined || this.venue == null) {
      this.toastr.warning('Venue is required');
      this.disableButtons = false;
      return false;
    }

    if (
      this.mailBody == '' ||
      this.mailBody == undefined ||
      this.mailBody == null
    ) {
      this.toastr.warning('Event Body is required');
      this.disableButtons = false;
      return false;
    }
    return true;
  }

  async getMeetingID() {
    if (
      this.mailSubject == '' ||
      this.mailSubject == undefined ||
      this.mailSubject == null
    ) {
      this.toastr.warning('Event Subject is required to generate link');
      this.disableButtons = false;
      return;
    }
    this.headerinfo.pageLoadingStarted(this);

    try {
      this.disableLinkBtn = true;
      let meetingInfo: MeetingInfo = {
        iD: 0,
        meetingJwt: '',
        meetingId: '',
        title: this.mailSubject,
        moduleID: this.moduleid,
        schoolID: this.schId,
        userID: 0,
      };
      let meetingRes:any= await this.meetingService.createMeetingLink(meetingInfo).toPromise();
      this.meetingID = meetingRes.meetId;
      this.venue = window.location.origin+`/live?meetingid=${this.meetingID}`;
    } catch (error) {
      console.error(error);
      this.disableLinkBtn = false;
    }
    this.headerinfo.pageLoadingDone(this);
  }
}
